import { WprBaseViewInfo } from '../../wpr-framework/view/WprBaseViewInfo';
import { WprBaseDIManage } from '../../wpr-framework/view/di/WprBaseDIManage';
import { WprDI_Control } from '../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../wpr-framework/view/control/WprControlInfo';
import { WprControRefreshMap } from '../../wpr-framework/view/control/map/WprControRefreshMap';

/**
 * テストスクロールビュー
 */
export class ScrollView extends WprBaseDIManage {
	// private 変数  ------------------------------------------------------------
	private m_ScrollPos: number 			= 0;		// スクロール位置
	private m_ViewInfo: WprBaseViewInfo		= null;		// ビュー情報
	// --------------------------------------------------------------------------

	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_Cpagetop: WprControlInfo	= null;			// 選択コントロール情報１
	// --------------------------------------------------------------------------

	// public メソッド  ----------------------------------------------------------
	/**
	 * ウインドウリサイズ通知
	 * @param width 幅
	 * @param height 高さ
	 */
	public onResizeWindow(width: number, height: number): void {
		if (width >= 0 && width <= 750) {
			let sz = width / 750;
			if (sz < 0.4) sz = 0.4;
			if (sz > 1) sz = 1;
			let html = document.getElementsByTagName('html');
			html[0].style.fontSize = sz + 'rem';
		}
		else {
			let html = document.getElementsByTagName('html');
			html[0].style.fontSize = '';
		}
	}

	/**
	 * DI用コントロール情報マップ取得
	 * @returns DI要コントロール情報マップ
	 */
	public getDIControlMap(): WprControRefreshMap {
		return this.m_ViewInfo.getDIControlMap();
	}

	/**
	 * DI元インスタンス取得
	 * @returns DI元インスタンス
	 */
	public getDIObjectFromInstance(): any {
		return this.m_ViewInfo;
	}

	/**
	 * ウインドウスクロール通知
	 * @param pageXOffset Xオフセット
	 * @param pageYOffset Yオフセット
	 */
	public onScrollWindow(viewInfo: WprBaseViewInfo, pageXOffset: number, pageYOffset: number): void {
		if (this.m_ViewInfo == null) {
			this.m_ViewInfo = viewInfo;
			this.execInjection();
		}
		if (pageYOffset > 300)
			viewInfo.setViewMode('topPage', 'show');
		else
			viewInfo.setViewMode('topPage', 'hide');
		const footer = document.getElementsByTagName('footer');
		let height = null;
		if (footer[0] !== undefined)
			height = footer[0].clientHeight;
		if (this.m_Cpagetop != null) {
			if (pageYOffset+window.innerHeight-100 > document.body.clientHeight - height)
				this.m_Cpagetop.setStyle({bottom: `${height+10}px`});
			else
				this.m_Cpagetop.setStyle({bottom: '107px'});
		}
	}

	/**
	 * 先頭へスクロール
	 */
	public scrollToTop(): void {
		this.m_ScrollPos = window.pageYOffset;
		this.onScrollTop();
	}
	// --------------------------------------------------------------------------

	// private メソッド  --------------------------------------------------------
	/**
	 * 先頭へスムーススクロールする
	 */
	private onScrollTop(): void {
		this.m_ScrollPos -= 40;
		if (this.m_ScrollPos < 0)
			this.m_ScrollPos = 0;
		window.scrollTo(0, this.m_ScrollPos);
		if (this.m_ScrollPos > 0)
			window.setTimeout(this.onScrollTop.bind(this), 10);
	}
	// --------------------------------------------------------------------------
}